export function Plan() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold">Protocol</h1>
        <p className="text-sm text-muted">The single source of truth. Open on any craving-to-drift day.</p>
      </div>

      <section className="card space-y-2">
        <h2 className="font-semibold text-accent">The 3 rules</h2>
        <ol className="list-decimal pl-5 space-y-1 text-sm">
          <li><b>75 minutes minimum</b> between Thyronorm and any food/coffee/whey/calcium.</li>
          <li><b>Paper notebook + 3 bullet points</b> before every Claude Code prompt. Explain every diff to yourself.</li>
          <li><b>Phone in living room by 11:30 PM.</b> No late-night date calls — schedule earlier.</li>
        </ol>
      </section>

      <section className="card">
        <h2 className="font-semibold text-accent mb-2">Morning routine</h2>
        <pre className="text-xs font-mono whitespace-pre-wrap">
{`6:45  Wake (alarm clock, not phone)
6:47  Thyronorm 75mcg + warm water. Nothing else.
6:50  Wash + balcony 10 min sunlight
7:00  Journal 5 min OR mobility
7:15  30 min easy walk (no phone)
7:45  Shower
8:00  BREAKFAST (75 min gap from dose)
8:30  Coffee + B12 1000mcg + D3 2000 IU
8:45  Read spec, write 3-bullet approach in notebook
9:00  Deep work block 1`}
        </pre>
      </section>

      <section className="card">
        <h2 className="font-semibold text-accent mb-2">Training split</h2>
        <pre className="text-xs font-mono whitespace-pre-wrap">
{`Mon  LOWER   Squat 3x5 · RDL 3x8 · BSS 3x8 · Calf 3x15 · Plank
Tue  RUN     Zone 2, 35 min + 10 min core
Wed  PUSH    Bench 3x5 · OHP 3x6 · Incline DB 3x8 · Dips 3x8 · Dead hang 3x30s
Thu  RUN     6 × (2 min hard / 2 min easy)
Fri  PULL    Pull-up 4x6 · Row 3x8 · Face pull · Curl · Leg raise · Dead hang
Sat  LONG    Progressive long run (6k → 32k by Nov)
Sun  REST    Yoga or walk`}
        </pre>
      </section>

      <section className="card">
        <h2 className="font-semibold text-accent mb-2">Marathon build (2026)</h2>
        <pre className="text-xs font-mono whitespace-pre-wrap">
{`Apr  base, long 6k
May  long 10k
Jun  long 14k (+ tempo)
Jul  long 18k
Aug  HALF MARATHON 21k   ← checkpoint
Sep  long 22k
Oct  long 28k
Nov  long 32k + taper begins
Dec  FULL MARATHON 42.2k`}
        </pre>
      </section>

      <section className="card">
        <h2 className="font-semibold text-accent mb-2">Nutrition (2400 kcal, 130g protein, veg)</h2>
        <pre className="text-xs font-mono whitespace-pre-wrap">
{`8:00   3 eggs + 2 chapati + veg + fruit     (500 kcal, 30g P)
11:00  Whey + greek yogurt + chia + muesli   (350 kcal, 40g P)
14:00  Rice + sambar/rasam + 100g paneer     (700 kcal, 25g P)
17:00  Sprouts chaat / chana + fruit         (300 kcal, 15g P)
20:30  2 chapati + dal + tofu curry + salad  (550 kcal, 25g P)`}
        </pre>
      </section>

      <section className="card">
        <h2 className="font-semibold text-accent mb-2">Supplements</h2>
        <ul className="text-sm list-disc pl-5 space-y-1">
          <li>Thyronorm 75 mcg — 6:47 AM, empty stomach, 75-min food gap</li>
          <li>B12 methylcobalamin 1000 mcg — with breakfast</li>
          <li>Vitamin D3 2000 IU — with breakfast</li>
          <li>Magnesium glycinate 400 mg — before bed</li>
          <li>Creatine monohydrate 5 g — with whey</li>
          <li>Zinc picolinate 15 mg — with any meal</li>
          <li>Selenium 200 mcg — 4×/week with meal</li>
        </ul>
      </section>

      <section className="card">
        <h2 className="font-semibold text-accent mb-2">Quarterly bloodwork</h2>
        <p className="text-sm text-muted mb-2">Fast 12 hrs. Draw before 9 AM. No lifting/sex 24 hrs prior.</p>
        <ul className="text-sm list-disc pl-5 space-y-1">
          <li>Thyroid: TSH, Free T4, Free T3</li>
          <li>Hormones: Total T, Free T, SHBG, LH, FSH, E2, DHEA-S, Prolactin, 8 AM Cortisol</li>
          <li>Metabolic: Fasting glucose, HbA1c, Fasting insulin, Lipid panel</li>
          <li>Inflammation: hs-CRP, Homocysteine</li>
          <li>Nutrients: B12, Ferritin, Vitamin D</li>
          <li>Liver/Kidney: AST/ALT/ALP/Bilirubin, Creatinine, Urea, Uric acid</li>
          <li>CBC</li>
        </ul>
      </section>

      <section className="card">
        <h2 className="font-semibold text-accent mb-2">Study (GRE + IELTS + hardware/security)</h2>
        <pre className="text-xs font-mono whitespace-pre-wrap">
{`Apr–Jun  GRE prep   — 1 hr/weekday, 3 hr Sat. Target 325+.
Jul      IELTS prep — 45 min/day. Target 8.0+.
Aug–Oct  SOP + LORs + school shortlist
Nov–Dec  Submit apps (CMU/GaTech/UT Austin/UMich/UCSD/NC State ECE)

Parallel, 30 min/day, 6 days/week:
Mo 1–2   Nand2Tetris (build a CPU from NAND)
Mo 3–4   Ben Eater 8-bit breadboard computer
Mo 5–6   pwn.college OR embedded security
         → one public GitHub repo by Oct`}
        </pre>
      </section>
    </div>
  );
}
